import { render } from "./MergeContacts.vue?vue&type=template&id=6d27bc2b&scoped=true"
import script from "./MergeContacts.vue?vue&type=script&lang=js"
export * from "./MergeContacts.vue?vue&type=script&lang=js"

import "./MergeContacts.vue?vue&type=style&index=0&id=6d27bc2b&lang=sass&scoped=true"

import exportComponent from "/home/forge/staging.ordinocrm.com/releases/20260610000542/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d27bc2b"]])

export default __exports__